import { Component } from '@angular/core';

@Component({
    selector: 'apc-save-back-action-buttons',
    templateUrl: './save-back-actions.component.html',
    styleUrls: ['../action-buttons.component.scss'],
    standalone: false
})
export class SaveBackActionsComponent {}
